import {
  InformationCircleIcon,
  CogIcon,
  KeyIcon,
  AdjustmentsIcon,
  UserGroupIcon,
} from '@heroicons/react/solid'
import { Route, Routes, useMatch, Navigate } from 'react-router-dom'
import { Aside, Main, Steps } from 'src/components'
import AdminCrypto from './Crypto'
import Info from './Info'
import AdminLogLevel from './LogLevel'
import ValidateOnlineUsersChart from './OnlineUsersChart/OnlineUsersChart'
import AdminOrganizationsConfig from './OrganizationsConfig'
import AdminOrganizationsOverview from './OrganizationsOverview'

import { ListIcon } from 'lucide-react'

const routes = [
  {
    path: 'info',
    element: <Info />,
    label: 'Info',
    icon: <InformationCircleIcon />,
  },
  {
    path: 'loglevel',
    element: <AdminLogLevel />,
    label: 'Log Level',
    icon: <AdjustmentsIcon />,
  },
  {
    path: 'config',
    element: <AdminOrganizationsConfig />,
    label: 'Organizations Config',
    icon: <CogIcon />,
  },
  {
    path: 'overview',
    element: <AdminOrganizationsOverview />,
    label: 'Organization Data',
    icon: <ListIcon />,
  },
  {
    path: 'crypto',
    element: <AdminCrypto />,
    label: 'Crypto',
    icon: <KeyIcon />,
  },
  {
    path: 'online-users-chart',
    element: <ValidateOnlineUsersChart />,
    label: 'Online Users Chart',
    icon: <UserGroupIcon />,
  },
]

type Props = {
  organization: string
  username: string
}

export default function AdminOrganization(props: Props) {
  const match = useMatch('/org/:orgId/:tab')

  const currentIndex =
    match && match.params.tab
      ? routes.findIndex((item) => item.path === match.params.tab)
      : -1

  return (
    <>
      <Aside
        title="Provisioning"
        hideExtraRow={currentIndex === -1}
        displayHelp
      >
        <Steps
          routes={routes.filter((item) => item.path !== 'online-users-chart')}
          currentIndex={currentIndex}
        />
      </Aside>

      <Main>
        <Routes>
          {routes.map((item) => (
            <Route key={item.path} path={item.path} element={item.element} />
          ))}
          <Route path="*" element={<Navigate to="./info" replace />} />
        </Routes>
      </Main>
    </>
  )
}
